import { useI18n } from '#/i18n/hooks/useI18n';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import { LocaleFacet } from '#/modules/search/components/Facet/LocaleFacet';
import { LocationTypeFacet } from '#/modules/search/components/Facet/LocationTypeFacet';
import { OrgAreasOfFocusFacet } from '#/modules/search/components/Facet/OrgAreasOfFocusFacet';
import { OrgTypeFacet } from '#/modules/search/components/Facet/OrgTypeFacet';
import { RecencyFacet } from '#/modules/search/components/Facet/RecencyFacet';
import { SearchRefinements } from '#/modules/search/components/Refinements/SearchRefinements';

import { InternshipKeywordsFacet } from '../InternshipKeywordsFacet';
import { PaymentFacet } from '../PaymentFacet';

export function SearchInternshipRefinements() {
  const { locale } = useI18n();

  return (
    <SearchRefinements
      listingType="INTERNSHIP"
      renderFacets={({ variant }) => {
        switch (locale) {
          case I18nLocale.EN:
            return (
              <>
                <LocationTypeFacet variant={variant} />
                <InternshipKeywordsFacet variant={variant} />
                <OrgAreasOfFocusFacet
                  variant={variant}
                  excludedAreasOfFocus={[]}
                />
                <OrgTypeFacet variant={variant} />
                <PaymentFacet variant={variant} />
                <LocaleFacet variant={variant} />
                <RecencyFacet variant={variant} />
              </>
            );

          case I18nLocale.ES:
            return (
              <>
                <LocaleFacet variant={variant} />
                <LocationTypeFacet variant={variant} />
                <InternshipKeywordsFacet variant={variant} />
                <OrgAreasOfFocusFacet
                  variant={variant}
                  excludedAreasOfFocus={[]}
                />
                <RecencyFacet variant={variant} />
                <PaymentFacet variant={variant} />
                <OrgTypeFacet variant={variant} />
              </>
            );

          case I18nLocale.PT:
            return (
              <>
                <LocaleFacet variant={variant} />
                <LocationTypeFacet variant={variant} />
                <InternshipKeywordsFacet variant={variant} />
                <OrgAreasOfFocusFacet
                  variant={variant}
                  excludedAreasOfFocus={[]}
                />
                <PaymentFacet variant={variant} />
                <RecencyFacet variant={variant} />
                <OrgTypeFacet variant={variant} />
              </>
            );
        }
      }}
    />
  );
}
